<div class="panel mb-4">
  @if (!appSettings.isMobile()) {
    <div class="step-header d-flex align-items-center gap-2">
      <h5 class="mb-0 text-dark fw-bold text-nowrap">
        <i class="fas fa-file-invoice text-danger me-2"></i>
        {{ mode === formMode.VIEW ? 'Detalle de Solicitud de Baja' : 'Solicitud de Baja de Cobertura' }}
      </h5>
      @if (mode === formMode.VIEW) {
        <span class="badge border" [ngClass]="requestData?.statusObj?.style || (requestData?.statusSlug === 'APPROVED' ? 'bg-success' : 'bg-warning text-dark')">
          {{ requestData?.statusObj?.name || (requestData?.statusSlug === 'APPROVED' ? 'Aprobado' : 'Borrador (En Proceso)') }}
        </span>
      }
    </div>
  }
  <div class="step-body" [class.p-3]="appSettings.isMobile()">
    <app-party-form [partyForm]="partyForm" [mode]="formMode.VIEW"></app-party-form>

    <div class="mt-3" [formGroup]="unsubscribeForm">
    <div class="mb-4">
      <label class="form-label fw-bold small text-uppercase text-muted">Vehículo Aplicable</label>
      @if (mode === formMode.VIEW) {
        <div class="p-3 border rounded bg-light">
          <strong class="text-danger fs-5 me-2">{{ getSelectedVehicle()?.plate || requestData?.vehicle?.plate }}</strong>
          <span class="text-dark font-weight-bold">
            {{ getSelectedVehicle()?.brandName || getSelectedVehicle()?.brand?.name || requestData?.vehicle?.brand?.name }}
            {{ getSelectedVehicle()?.modelName || getSelectedVehicle()?.model?.name || requestData?.vehicle?.model?.name }}
          </span>
          <span class="text-muted ms-2">({{ getSelectedVehicle()?.year || requestData?.vehicle?.year }})</span>
        </div>
      } @else {
        <app-sheet-select
          [items]="vehicleSelectItems()"
          bindLabel="selectLabel"
          bindValue="uuid"
          title="Vehículo Aplicable"
          placeholder="Seleccione el vehículo"
          formControlName="referenceUuid"
          [clearable]="false"
          [searchable]="vehicleSelectItems().length > 5">
        </app-sheet-select>
        <div class="form-text small text-info mt-1">
          <i class="fas fa-info-circle me-1"></i> Seleccione el vehículo que desea dar de baja de la cobertura FPV.
        </div>
      }
    </div>

    <div class="mb-0">
      <label class="form-label fw-bold small text-uppercase text-muted">Causal de Desafiliación (Reglamento FPV)</label>
      @if (mode === formMode.VIEW) {
        <div class="p-3 border rounded bg-light">
          <strong class="text-dark">{{ getCausalName() }}</strong>
          @if (requestData?.reason) {
            <div class="text-muted small mt-2">{{ requestData.reason }}</div>
          }
        </div>
      } @else {
        <app-sheet-select
          [items]="causalesList()"
          bindLabel="name"
          bindValue="code"
          title="Causal de Baja"
          placeholder="Seleccione la Causal de Baja"
          formControlName="causalCode"
          [clearable]="false"
          [searchable]="causalesList().length > 5">
        </app-sheet-select>
        <div class="form-text small mt-1">
          @if (isVoluntarySelected()) {
            <span class="text-primary fw-bold">
              <i class="fas fa-paper-plane me-1"></i> Se enviará un correo con enlace de confirmación al socio. Prima del periodo abierto se cobra hasta el cierre.
            </span>
          } @else {
            <span class="text-secondary fw-semibold">
              <i class="fas fa-gavel me-1"></i> Causal reglamentaria: al aprobar, el vehículo queda inactivo (sin prima residual). Docs según BPM del proceso.
            </span>
          }
        </div>
      }
    </div>
    </div>
  </div>

  @if (!appSettings.isMobile()) {
    <div class="step-footer">
      @if (mode === formMode.VIEW) {
        <button type="button" class="btn btn-outline-danger btn-sm px-3" (click)="exportBajaPDF()">
          <i class="fas fa-file-pdf me-1"></i> Generar Comprobante (PDF)
        </button>
      }
      @if (mode !== formMode.VIEW) {
        <button type="button" class="btn btn-primary btn-sm px-4" (click)="submitBaja()" [disabled]="isSubmitting()">
          @if (isSubmitting()) {
            <span class="spinner-border spinner-border-sm me-1"></span>
          } @else {
            <i class="fas fa-paper-plane me-1"></i>
          }
          Enviar Solicitud
        </button>
      }
    </div>
  }
</div>

@if (mode !== formMode.VIEW) {
  <app-mobile-footer [visible]="true">
    <button type="button" class="btn btn-primary btn-sm w-100" (click)="submitBaja()" [disabled]="isSubmitting()">
      @if (isSubmitting()) {
        <span class="spinner-border spinner-border-sm me-1"></span>
      } @else {
        <i class="fas fa-paper-plane me-1"></i>
      }
      Enviar
    </button>
  </app-mobile-footer>
}

<app-step-approval-modal
  [request]="approvalRequest()"
  [isProcessing]="isSubmitting()"
  (confirmed)="onStepApprovalConfirmed($event)">
</app-step-approval-modal>

<!-- Tabla oculta para reporte de baja -->
<div style="display: none;">
@if (!requestData) {
    <table id="hidden-baja-table" style="width: 100%; font-family: 'Helvetica', Arial, sans-serif; color: #212529; background-color: #ffffff; border: 1px solid #999a9a;">
        <tbody>
            <tr style="background-color: #e5e6e6; border-bottom: 2px solid #7d8287;">
                <th colspan="4" style="text-align: left; padding: 12px; font-size: 10pt; text-transform: uppercase; font-weight: bold; color: #343A40;">
                    1. IDENTIFICACIÓN DEL SOCIO / PROPIETARIO
                </th>
            </tr>
            <tr style="border-bottom: 1px solid #DEE2E6;">
                <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; width: 20%; font-size: 9pt;">Rut:</td>
                <td style="padding: 8px; width: 30%; font-size: 9pt;">{{ partyData?.rut }}</td>
                <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; width: 20%; font-size: 9pt;">Tipo de Socio:</td>
                <td style="padding: 8px; width: 30%; font-size: 9pt;">{{ findGroup(partyData?.groupCode) }}</td>
            </tr>
            <tr style="border-bottom: 1px solid #DEE2E6;">
                <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Nombres:</td>
                <td colspan="3" style="padding: 8px; font-size: 9pt;">{{ partyData?.names }} {{ partyData?.lastNames }}</td>
            </tr>
            <tr style="border-bottom: 1px solid #DEE2E6;">
                <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Correo:</td>
                <td style="padding: 8px; font-size: 9pt;">{{ partyData?.mail || 'No registrado' }}</td>
                <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Móvil:</td>
                <td style="padding: 8px; font-size: 9pt;">{{ partyData?.mobileNumber || 'No registrado' }}</td>
            </tr>
            <tr style="border-bottom: 1px solid #DEE2E6;">
                <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Entidad:</td>
                <td colspan="3" style="padding: 8px; font-size: 9pt;">
                    {{ partyData?.entityCode }} - {{ getEntityName(partyData?.entityCode) }}
                </td>
            </tr>

            @if(getSelectedVehicle()){
            <tr style="background-color: #e5e6e6; border-bottom: 2px solid #7d8287;">
                <th colspan="4" style="text-align: left; padding: 12px; font-size: 10pt; text-transform: uppercase; font-weight: bold; color: #343A40;">
                    2. IDENTIFICACIÓN DEL VEHÍCULO
                </th>
            </tr>
            <tr style="border-bottom: 1px solid #DEE2E6;">
                <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Patente:</td>
                <td style="padding: 8px; font-size: 10pt;">{{ getSelectedVehicle()?.plate }}</td>
                <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Año:</td>
                <td style="padding: 8px; font-size: 9pt;">{{ getSelectedVehicle()?.year }}</td>
            </tr>
            <tr style="border-bottom: 1px solid #DEE2E6;">
                <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Marca / Modelo:</td>
                <td colspan="3" style="padding: 8px; font-size: 9pt;">{{ getSelectedVehicle()?.brandName }} {{ getSelectedVehicle()?.modelName }}</td>
            </tr>
            <tr style="border-bottom: 1px solid #DEE2E6;">
                <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Color:</td>
                <td style="padding: 8px; font-size: 9pt;">{{ getSelectedVehicle()?.colorName || getSelectedVehicle()?.color || 'N/A' }}</td>
                <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">VIN / Motor:</td>
                <td style="padding: 8px; font-size: 9pt;">{{ getSelectedVehicle()?.vin || 'N/A' }}</td>
            </tr>
            }

            <tr style="background-color: #e5e6e6; border-bottom: 2px solid #7d8287;">
                <th colspan="4" style="text-align: left; padding: 12px; font-size: 10pt; text-transform: uppercase; font-weight: bold; color: #343A40;">
                    3. MOTIVO Y FECHA DE TRÁMITE
                </th>
            </tr>
            <tr style="border-bottom: 1px solid #DEE2E6;">
                <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Fecha Solicitud:</td>
                <td style="padding: 8px; font-size: 9pt;">{{ getCurrentDateFormatted() }}</td>
                <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Estado:</td>
                <td style="padding: 8px; font-weight: bold;font-size: 9pt;">PROCESANDO</td>
            </tr>
            <tr style="border-bottom: 1px solid #DEE2E6;">
                <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Motivo:</td>
                <td colspan="3" style="padding: 8px; font-size: 9pt; font-style: italic;">{{ unsubscribeForm.get('reason')?.value || 'No especificado' }}</td>
            </tr>
            <tr style="background-color: #e5e6e6; border-bottom: 2px solid #7d8287;">
                <td colspan="4" style="text-align: justify; padding: 25px; color: #6C757D; font-size: 8.5pt; line-height: 1.6;">
                    Declaro conocer y estar dispuesto a respetar los reglamentos del Fondo de Protección Vehicular (FPV) y renuncio a toda acción civil en contra de este Fondo, cuyo fin es prestar servicio a los religiosos o empleados de la Organización Iglesia Adventista. Acepto, además, las decisiones que la comisión del Fondo P.V. determine de manera libre y espontánea en relación a esta solicitud de baja.
                </td>
            </tr>
        </tbody>
    </table>
} @else {
    <table id="hidden-baja-table" style="width: 100%; font-family: 'Helvetica', Arial, sans-serif; color: #212529; background-color: #ffffff; border: 1px solid #999a9a;">
        <tbody>
            <tr style="background-color: #e5e6e6; border-bottom: 2px solid #7d8287;">
                <th colspan="4" style="text-align: left; padding: 12px; font-size: 10pt; text-transform: uppercase; font-weight: bold; color: #343A40;">
                    1. IDENTIFICACIÓN DEL SOCIO / PROPIETARIO
                </th>
            </tr>
            <tr style="border-bottom: 1px solid #DEE2E6;">
                <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; width: 20%; font-size: 9pt;">Rut:</td>
                <td style="padding: 8px; width: 30%; font-size: 9pt;">{{ requestData?.party?.rut }}</td>
                <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; width: 20%; font-size: 9pt;">Tipo de Socio:</td>
                <td style="padding: 8px; width: 30%; font-size: 9pt;">{{ requestData?.party?.groupName || 'Socio Afiliado' }}</td>
            </tr>
            <tr style="border-bottom: 1px solid #DEE2E6;">
                <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Nombres:</td>
                <td colspan="3" style="padding: 8px; font-size: 9pt;">{{ requestData?.party?.names }} {{ requestData?.party?.lastNames }}</td>
            </tr>
            <tr style="border-bottom: 1px solid #DEE2E6;">
                <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Correo Socio:</td>
                <td style="padding: 8px; font-size: 9pt;">{{ requestData?.party?.mail || 'No registrado' }}</td>
                <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Móvil:</td>
                <td style="padding: 8px; font-size: 9pt;">{{ requestData?.party?.mobileNumber || 'No registrado' }}</td>
            </tr>
            <tr style="border-bottom: 1px solid #DEE2E6;">
                <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Entidad:</td>
                <td colspan="3" style="padding: 8px; font-size: 9pt;">
                    {{ requestData?.entity?.code }} - {{ requestData?.entity?.name }}
                </td>
            </tr>

            @if(requestData?.vehicle){
            <tr style="background-color: #e5e6e6; border-bottom: 2px solid #7d8287;">
                <th colspan="4" style="text-align: left; padding: 12px; font-size: 10pt; text-transform: uppercase; font-weight: bold; color: #343A40;">
                    2. IDENTIFICACIÓN DEL VEHÍCULO
                </th>
            </tr>
            <tr style="border-bottom: 1px solid #DEE2E6;">
                <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Patente:</td>
                <td style="padding: 8px; font-size: 10pt;">{{ requestData?.vehicle?.plate }}</td>
                <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Año:</td>
                <td style="padding: 8px; font-size: 9pt;">{{ requestData?.vehicle?.year }}</td>
            </tr>
            <tr style="border-bottom: 1px solid #DEE2E6;">
                <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Marca / Modelo:</td>
                <td colspan="3" style="padding: 8px; font-size: 9pt;">{{ requestData?.vehicle?.brand?.name }} {{ requestData?.vehicle?.model?.name }}</td>
            </tr>
            <tr style="border-bottom: 1px solid #DEE2E6;">
                <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Color:</td>
                <td style="padding: 8px; font-size: 9pt;">{{ requestData?.vehicle?.colorName || requestData?.vehicle?.color || 'N/A' }}</td>
                <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">VIN / Motor:</td>
                <td style="padding: 8px; font-size: 9pt;">{{ requestData?.vehicle?.vin || 'N/A' }}</td>
            </tr>
            }

            <tr style="background-color: #e5e6e6; border-bottom: 2px solid #7d8287;">
                <th colspan="4" style="text-align: left; padding: 12px; font-size: 10pt; text-transform: uppercase; font-weight: bold; color: #343A40;">
                    3. MOTIVO, TOKEN Y FECHA DE APROBACIÓN
                </th>
            </tr>
            <tr style="border-bottom: 1px solid #DEE2E6;">
                <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Estado Trámite:</td>
                <td style="padding: 8px; font-weight: bold; font-size: 9pt; color: #198754;">{{ requestData?.statusObj?.name || (requestData?.statusSlug === 'APPROVED' ? 'APROBADO' : 'EN PROCESO') }}</td>
                <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Correo Token:</td>
                <td style="padding: 8px; font-size: 9pt; font-weight: bold;">{{ requestData?.party?.mail || 'No registrado' }}</td>
            </tr>
            <tr style="border-bottom: 1px solid #DEE2E6;">
                <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Token Autorización:</td>
                <td colspan="3" style="padding: 8px; font-size: 9pt; font-family: monospace; font-weight: bold; color: #d9534f; word-break: break-all;">
                    {{ requestData?.confirmationToken || token }}
                </td>
            </tr>
            <tr style="border-bottom: 1px solid #DEE2E6;">
                <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Fecha Aprobación:</td>
                <td colspan="3" style="padding: 8px; font-size: 9pt; font-weight: bold; color: #0d6efd;">
                    {{ confirmedDate || (requestData?.confirmedAt ? (requestData?.confirmedAt | date: 'dd/MM/yyyy HH:mm:ss') : 'Pendiente de confirmación') }}
                </td>
            </tr>
            <tr style="border-bottom: 1px solid #DEE2E6;">
                <td style="background-color: #e5e6e6; font-weight: bold; padding: 8px; font-size: 9pt;">Motivo / Causal:</td>
                <td colspan="3" style="padding: 8px; font-size: 9pt; font-style: italic;">{{ requestData?.reason || 'No especificado' }}</td>
            </tr>
            <tr style="background-color: #e5e6e6; border-bottom: 2px solid #7d8287;">
                <td colspan="4" style="text-align: justify; padding: 25px; color: #6C757D; font-size: 8.5pt; line-height: 1.6;">
                    Declaro conocer y estar dispuesto a respetar los reglamentos del Fondo de Protección Vehicular (FPV) y renuncio a toda acción civil en contra de este Fondo, cuyo fin es prestar servicio a los religiosos o empleados de la Organización Iglesia Adventista. Acepto, además, las decisiones que la comisión del Fondo P.V. determine de manera libre y espontánea en relación a esta solicitud de baja.
                </td>
            </tr>
        </tbody>
    </table>
}
</div>

<ng-template #previewModal let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title">Previsualización de Documento</h4>
        <div class="ms-auto d-flex align-items-center">
            <a [href]="pdfSrc" class="btn btn-success btn-sm me-2" target="_blank" *ngIf="pdfSrc">
                <i class="fas fa-external-link-alt me-1"></i> Abrir en nueva pestaña
            </a>
            <button type="button" class="btn-close" (click)="d('Cross click')"></button>
        </div>
    </div>
    <div class="modal-body p-0">
        <iframe *ngIf="pdfSrc" [src]="pdfSrc" width="100%" height="600px" style="border: none;"></iframe>
    </div>
</ng-template>
